/* Splash entrance */
function enterSite(targetPage) {
  var splash = document.getElementById('splashPage');
  if (splash) {
    splash.classList.add('hidden');
    document.body.classList.remove('splash-active');
  }
  setTimeout(function() {
    if (typeof window.showPage === 'function' && targetPage) {
      window.showPage(targetPage);
    }
    if (splash) splash.style.display = 'none';
  }, 600);
}

var nav = document.getElementById('navbar');
if (nav) {
  window.addEventListener('scroll', function() {
    nav.classList.toggle('scrolled', window.scrollY > 50);
  });
}

/* FAQ accordion moved to aurum-faq-accordion.js */

// Quotes Carousel
(function() {
  var slides = document.querySelectorAll('.quote-slide');
  var dots = document.querySelectorAll('.quote-dot');
  var prevBtn = document.querySelector('.quote-prev');
  var nextBtn = document.querySelector('.quote-next');
  var currentIndex = 0;
  var autoPlayInterval;

  if (slides.length === 0) return;

  function showSlide(index) {
    slides.forEach(function(slide, i) {
      slide.classList.remove('active', 'prev');
      if (i === currentIndex) slide.classList.add('prev');
    });
    dots.forEach(function(dot) { dot.classList.remove('active'); });
    currentIndex = index;
    if (currentIndex >= slides.length) currentIndex = 0;
    if (currentIndex < 0) currentIndex = slides.length - 1;
    slides[currentIndex].classList.add('active');
    if (dots[currentIndex]) dots[currentIndex].classList.add('active');
  }
  function nextSlide() { showSlide(currentIndex + 1); }
  function prevSlide() { showSlide(currentIndex - 1); }
  function startAutoPlay() { autoPlayInterval = setInterval(nextSlide, 5000); }
  function stopAutoPlay() { clearInterval(autoPlayInterval); }

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function() { stopAutoPlay(); prevSlide(); startAutoPlay(); });
    nextBtn.addEventListener('click', function() { stopAutoPlay(); nextSlide(); startAutoPlay(); });
  }
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { stopAutoPlay(); showSlide(i); startAutoPlay(); });
  });

  // First slide is already visible via inline style. Clear it once JS takes over, then enable transitions.
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      slides.forEach(function(s) {
        s.removeAttribute('style');
        s.style.transition = 'all 0.5s ease';
      });
      startAutoPlay();
    });
  });
})();

// Gold Price Historical Chart
(function() {
  // Approximate annual average XAUEUR prices 2000-2024
  var data = [
    {y:2000,v:315},{y:2001,v:310},{y:2002,v:330},{y:2003,v:330},{y:2004,v:330},
    {y:2005,v:350},{y:2006,v:480},{y:2007,v:500},{y:2008,v:620},{y:2009,v:680},
    {y:2010,v:950},{y:2011,v:1200},{y:2012,v:1290},{y:2013,v:1000},{y:2014,v:940},
    {y:2015,v:1050},{y:2016,v:1170},{y:2017,v:1100},{y:2018,v:1070},{y:2019,v:1360},
    {y:2020,v:1550},{y:2021,v:1530},{y:2022,v:1720},{y:2023,v:1850},{y:2024,v:2200}
  ];

  function drawGoldChart() {
    var canvas = document.getElementById('goldPriceChart');
    if (!canvas) return;
    var wrap = canvas.parentElement;
    var dpr = window.devicePixelRatio || 1;
    var W = wrap.clientWidth;
    var H = wrap.clientHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    var pad = {top:30, right:20, bottom:50, left:65};
    var cw = W - pad.left - pad.right;
    var ch = H - pad.top - pad.bottom;

    var minV = 0;
    var maxV = Math.ceil(Math.max.apply(null, data.map(function(d){return d.v;})) / 500) * 500;

    function xPos(i) { return pad.left + (i / (data.length - 1)) * cw; }
    function yPos(v) { return pad.top + ch - ((v - minV) / (maxV - minV)) * ch; }

    // Grid
    ctx.strokeStyle = 'rgba(255,255,255,0.06)';
    ctx.lineWidth = 1;
    var steps = 5;
    for (var s = 0; s <= steps; s++) {
      var gv = minV + (maxV - minV) * (s / steps);
      var gy = yPos(gv);
      ctx.beginPath(); ctx.moveTo(pad.left, gy); ctx.lineTo(W - pad.right, gy); ctx.stroke();
      ctx.fillStyle = '#666054';
      ctx.font = '11px Outfit';
      ctx.textAlign = 'right';
      ctx.fillText(Math.round(gv).toLocaleString('sk') + ' €', pad.left - 10, gy + 4);
    }

    // X labels
    ctx.textAlign = 'center';
    ctx.fillStyle = '#666054';
    ctx.font = '11px Outfit';
    for (var i = 0; i < data.length; i++) {
      if (i % 4 === 0 || i === data.length - 1) {
        ctx.fillText(data[i].y, xPos(i), H - pad.bottom + 20);
      }
    }

    // Gradient fill
    var grad = ctx.createLinearGradient(0, pad.top, 0, pad.top + ch);
    grad.addColorStop(0, 'rgba(201,168,76,0.25)');
    grad.addColorStop(0.6, 'rgba(201,168,76,0.08)');
    grad.addColorStop(1, 'rgba(201,168,76,0)');
    ctx.beginPath();
    ctx.moveTo(xPos(0), yPos(data[0].v));
    for (var i = 1; i < data.length; i++) {
      var xc = (xPos(i-1) + xPos(i)) / 2;
      var yc = (yPos(data[i-1].v) + yPos(data[i].v)) / 2;
      ctx.quadraticCurveTo(xPos(i-1), yPos(data[i-1].v), xc, yc);
    }
    ctx.quadraticCurveTo(xPos(data.length-2), yPos(data[data.length-2].v), xPos(data.length-1), yPos(data[data.length-1].v));
    ctx.lineTo(xPos(data.length-1), pad.top + ch);
    ctx.lineTo(xPos(0), pad.top + ch);
    ctx.closePath();
    ctx.fillStyle = grad;
    ctx.fill();

    // Line
    ctx.beginPath();
    ctx.moveTo(xPos(0), yPos(data[0].v));
    for (var i = 1; i < data.length; i++) {
      var xc = (xPos(i-1) + xPos(i)) / 2;
      var yc = (yPos(data[i-1].v) + yPos(data[i].v)) / 2;
      ctx.quadraticCurveTo(xPos(i-1), yPos(data[i-1].v), xc, yc);
    }
    ctx.quadraticCurveTo(xPos(data.length-2), yPos(data[data.length-2].v), xPos(data.length-1), yPos(data[data.length-1].v));
    ctx.strokeStyle = '#C9A84C';
    ctx.lineWidth = 2.5;
    ctx.stroke();

    // Dots at key points
    [0, 5, 10, 15, 20, 24].forEach(function(idx) {
      if (idx >= data.length) return;
      ctx.beginPath();
      ctx.arc(xPos(idx), yPos(data[idx].v), 4, 0, Math.PI * 2);
      ctx.fillStyle = '#C9A84C';
      ctx.fill();
      ctx.strokeStyle = '#161616';
      ctx.lineWidth = 2;
      ctx.stroke();
    });

    // Last point label
    var last = data[data.length - 1];
    ctx.fillStyle = '#C9A84C';
    ctx.font = '600 13px Outfit';
    ctx.textAlign = 'right';
    ctx.fillText(last.v.toLocaleString('sk') + ' €', xPos(data.length-1) - 10, yPos(last.v) - 12);
    ctx.font = '300 10px Outfit';
    ctx.fillStyle = '#A09880';
    ctx.fillText(last.y, xPos(data.length-1) - 10, yPos(last.v) - 0);

    // First point label
    var first = data[0];
    ctx.fillStyle = '#A09880';
    ctx.font = '500 12px Outfit';
    ctx.textAlign = 'left';
    ctx.fillText(first.v + ' €', xPos(0) + 10, yPos(first.v) - 8);
  }

  // Draw on page show and resize
  var goldChartObs = new MutationObserver(function() {
    var page = document.querySelector('[data-page="why-gold"]');
    if (page && page.classList.contains('active')) {
      setTimeout(drawGoldChart, 100);
    }
  });
  goldChartObs.observe(document.body, {subtree:true, attributes:true, attributeFilter:['class']});
  window.addEventListener('resize', function() {
    var page = document.querySelector('[data-page="why-gold"]');
    if (page && page.classList.contains('active')) drawGoldChart();
  });
  // Initial draw if already visible
  setTimeout(function() {
    var page = document.querySelector('[data-page="why-gold"]');
    if (page && page.classList.contains('active')) drawGoldChart();
  }, 300);

  window.drawGoldChart = drawGoldChart;
})();

// Contact Form
(function() {
  var toggle = document.getElementById('ctaContactToggle');
  var wrap = document.getElementById('contactFormWrap');
  var form = document.getElementById('contactForm');
  var success = document.getElementById('contactFormSuccess');
  var confirmEmail = document.getElementById('cfConfirmEmail');
  var submitBtn = document.getElementById('cfSubmitBtn');
  var submitText = document.getElementById('cfSubmitText');
  var submitLoader = document.getElementById('cfSubmitLoader');

  if (toggle && wrap) {
    toggle.addEventListener('click', function() {
      if (wrap.style.display === 'none' || !wrap.style.display) {
        wrap.style.display = 'block';
        form.style.display = 'block';
        success.style.display = 'none';
        setTimeout(function() {
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      } else {
        wrap.style.display = 'none';
      }
    });
  }

  if (form) {
    // Clear error on input
    form.querySelectorAll('input, select, textarea').forEach(function(el) {
      el.addEventListener('input', function() { el.classList.remove('error'); });
      el.addEventListener('change', function() { el.classList.remove('error'); });
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var valid = true;
      var fields = ['cfName', 'cfEmail', 'cfSubject', 'cfMessage', 'cfConsent'];
      fields.forEach(function(id) {
        var el = document.getElementById(id);
        if (!el) return;
        if (el.type === 'checkbox') {
          if (!el.checked) { valid = false; el.closest('.checkbox-label').querySelector('.checkbox-custom').style.borderColor = '#c0392b'; }
          else { el.closest('.checkbox-label').querySelector('.checkbox-custom').style.borderColor = ''; }
        } else if (!el.value || !el.value.trim()) {
          valid = false; el.classList.add('error');
        } else {
          el.classList.remove('error');
        }
      });
      // Email format
      var emailEl = document.getElementById('cfEmail');
      if (emailEl && emailEl.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value.trim())) {
        valid = false; emailEl.classList.add('error');
      }

      if (!valid) return;

      // Simulate sending
      submitText.style.display = 'none';
      submitLoader.style.display = 'inline-block';
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.6';

      setTimeout(function() {
        var email = document.getElementById('cfEmail').value.trim();
        confirmEmail.textContent = email;
        form.style.display = 'none';
        success.style.display = 'block';
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Reset button state
        submitText.style.display = 'inline';
        submitLoader.style.display = 'none';
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
      }, 1500);
    });
  }
})();

// Footer / any link: href="#contact-form" opens the contact form
document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href*="#contact-form"]');
  if (!link) return;
  e.preventDefault();
  var wrap = document.getElementById('contactFormWrap');
  var form = document.getElementById('contactForm');
  var success = document.getElementById('contactFormSuccess');
  if (wrap) {
    wrap.style.display = 'block';
    if (form) form.style.display = 'block';
    if (success) success.style.display = 'none';
    setTimeout(function() {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }
});

function resetContactForm() {
  var wrap = document.getElementById('contactFormWrap');
  var form = document.getElementById('contactForm');
  var success = document.getElementById('contactFormSuccess');
  if (wrap) wrap.style.display = 'none';
  if (form) { form.style.display = 'block'; form.reset(); }
  if (success) success.style.display = 'none';
}

// Weight converter
(function() {
  var factors = { ozt:31.1034768, g:1, kg:1000, gr:0.06479891, dwt:1.55517384, tola:11.6638038, tael:37.429, baht:15.244 };
  var names = { ozt:'oz t', g:'g', kg:'kg', gr:'gr', dwt:'dwt', tola:'tola', tael:'tael', baht:'baht' };
  var valEl=document.getElementById('convVal'), fromEl=document.getElementById('convFrom');
  var toEl=document.getElementById('convTo'), outEl=document.getElementById('convOut');
  var unitEl=document.getElementById('convOutUnit'), swapBtn=document.getElementById('convSwap');
  function calc() {
    var v=parseFloat(valEl.value)||0, grams=v*factors[fromEl.value], result=grams/factors[toEl.value];
    var d=result<0.01?6:result<100?4:2;
    outEl.textContent=result.toLocaleString('sk-SK',{minimumFractionDigits:d,maximumFractionDigits:d});
    unitEl.textContent=names[toEl.value];
  }
  if(valEl&&fromEl&&toEl){
    valEl.addEventListener('input',calc); fromEl.addEventListener('change',calc);
    toEl.addEventListener('change',calc);
    if(swapBtn){swapBtn.addEventListener('click',function(){var t=fromEl.value;fromEl.value=toEl.value;toEl.value=t;calc();});}
    calc();
  }
})();
// Fallback: attach swap listener after DOM is fully ready
document.addEventListener('DOMContentLoaded', function() {
  var swapBtn = document.getElementById('convSwap');
  if (swapBtn && !swapBtn._swapAttached) {
    swapBtn._swapAttached = true;
    swapBtn.addEventListener('click', function() {
      var fromEl = document.getElementById('convFrom');
      var toEl = document.getElementById('convTo');
      var valEl = document.getElementById('convVal');
      if (fromEl && toEl) {
        var t = fromEl.value; fromEl.value = toEl.value; toEl.value = t;
        var v = parseFloat(valEl.value) || 0;
        var factors = { ozt:31.1034768, g:1, kg:1000, gr:0.06479891, dwt:1.55517384, tola:11.6638038, tael:37.429, baht:15.244 };
        var names = { ozt:'oz t', g:'g', kg:'kg', gr:'gr', dwt:'dwt', tola:'tola', tael:'tael', baht:'baht' };
        var grams = v * factors[fromEl.value], result = grams / factors[toEl.value];
        var d = result < 0.01 ? 6 : result < 100 ? 4 : 2;
        var outEl = document.getElementById('convOut');
        var unitEl = document.getElementById('convOutUnit');
        if (outEl) outEl.textContent = result.toLocaleString('sk-SK', { minimumFractionDigits: d, maximumFractionDigits: d });
        if (unitEl) unitEl.textContent = names[toEl.value];
      }
    });
  }
});


// SPA Page Router
// Hamburger toggle (mobile menu)
(function() {
  var hamburger = document.querySelector('.nav-hamburger');
  var navLinksContainer = document.querySelector('.nav-links');
  if (hamburger) {
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('open');
      navLinksContainer.classList.toggle('open');
    });
  }
})();


// ══════════════════════════════════════════════
// KOŠÍK (Cart)
// ══════════════════════════════════════════════
(function() {
  var cartItems = [];

  function getFormId(t) {
    if (t === 'jednorazovy') return 'Jednorazovy';
    if (t === 'ppn') return 'PPN';
    if (t === 'registracia') return 'Registracia';
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function updateCartUI() {
    var badge = document.getElementById('cartBadge');
    var itemsEl = document.getElementById('cartPanelItems');
    var footerEl = document.getElementById('cartPanelFooter');
    var notice = document.getElementById('zoneCartNotice');

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        if (itemsEl) {
          if (cart.items.length === 0) {
            itemsEl.innerHTML = '<p class="cart-empty">Košík je prázdny</p>';
          } else {
            var html = '';
            cart.items.forEach(function(item) {
              html += '<div class="cart-item">';
              if (item.image) {
                html += '<img src="' + item.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2') + '" alt="' + item.product_title + '" class="cart-item-img" style="width:60px;height:60px;object-fit:contain;border-radius:0.5rem;flex-shrink:0;">';
              }
              html += '<div style="flex:1;min-width:0;"><div class="cart-item-name">';
              html += item.product_title + '</div>';
              html += '<div style="font-size:0.7rem;color:var(--gray);">' + item.vendor;
              if (item.product_type) html += ' · ' + item.product_type;
              html += '</div></div>';
              html += '<div style="display:flex;flex-direction:column;align-items:center;gap:0.25rem;">';
              html += '<span class="cart-item-price">€' + (item.final_line_price / 100).toLocaleString('sk-SK', {minimumFractionDigits: 2}) + '</span>';
              html += '<div class="aurum-cart-qty">';
              html += '<button type="button" class="aurum-cart-qty-btn" onclick="changeCartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>';
              html += '<span class="aurum-cart-qty-value">' + item.quantity + '</span>';
              html += '<button type="button" class="aurum-cart-qty-btn" onclick="changeCartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>';
              html += '</div>';
              html += '</div></div>';
            });
            itemsEl.innerHTML = html;
          }
        }
        if (footerEl) footerEl.style.display = cart.items.length > 0 ? 'block' : 'none';
        if (notice) notice.style.display = cart.items.length > 0 ? 'flex' : 'none';

        // Keep local array in sync
        cartItems = cart.items.map(function(item) {
          return { name: item.product_title, weight: item.vendor, price: '€' + (item.final_line_price / 100).toLocaleString('sk-SK', {minimumFractionDigits: 2}), sku: item.sku };
        });
      });
  }

  window.addToCart = function(btn) {
    var card = btn.closest('.product-card');
    var variantId = btn.getAttribute('data-variant-id') || (card ? card.getAttribute('data-variant-id') : '');
    if (!variantId) return;

    var originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Pridávam...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function(item) {
      // Also keep local cart for panel UI
      var name, weight, price, sku;
      if (card) {
        name = card.querySelector('h4') ? card.querySelector('h4').textContent : '';
        weight = card.querySelector('.product-weight') ? card.querySelector('.product-weight').textContent : '';
        price = card.querySelector('.product-price') ? card.querySelector('.product-price').textContent : '';
        sku = card.getAttribute('data-sku') || '';
      } else {
        name = document.getElementById('modalTitle') ? document.getElementById('modalTitle').textContent : '';
        weight = '';
        price = document.getElementById('modalPrice') ? document.getElementById('modalPrice').textContent : '';
        sku = '';
      }
      cartItems.push({ name: name, weight: weight, price: price, sku: sku });
      updateCartUI();

      // Success feedback
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Pridané ✓';
      btn.style.background = 'var(--gold)';
      btn.style.color = 'var(--black)';
      btn.style.borderColor = 'var(--gold)';
      setTimeout(function() {
        btn.innerHTML = originalHtml;
        btn.style.background = '';
        btn.style.color = '';
        btn.style.borderColor = '';
        btn.disabled = false;
      }, 1500);

      // Update Shopify cart count badge
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var badge = document.querySelector('.cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
    })
    .catch(function() {
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Chyba';
      btn.style.background = '#c0392b';
      btn.style.borderColor = '#c0392b';
      setTimeout(function() {
        btn.innerHTML = originalHtml;
        btn.style.background = '';
        btn.style.color = '';
        btn.style.borderColor = '';
        btn.disabled = false;
      }, 2000);
    });
  };

  window.removeFromCart = function(index) {
    cartItems.splice(index, 1);
    updateCartUI();
  };

  window.removeCartItem = function(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: 0 })
    }).then(function() { updateCartUI(); });
  };

  window.changeCartQty = function(key, qty) {
    if (qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty })
    }).then(function() { updateCartUI(); });
  };

  window.toggleCartPanel = function() {
    if (window.innerWidth <= 1024) {
      var drawer = document.getElementById('aurum-cart-drawer');
      if (drawer) {
        customElements.whenDefined('cart-drawer-component').then(function() {
          if (typeof drawer.open === 'function') {
            drawer.open();
          } else if (drawer.querySelector('dialog')) {
            drawer.querySelector('dialog').showModal();
          }
        });
      }
      return;
    }
    var panel = document.getElementById('cartPanel');
    if (panel) panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
  };

  window.cartGoToZone = function() {
    var panel = document.getElementById('cartPanel');
    if (panel) panel.style.display = 'none';
    // Navigate to zone and auto-select jednorazový
    if (typeof showPage === 'function') showPage('zona');
    setTimeout(function() { window.zoneSelectType('jednorazovy'); }, 200);
  };

  window.getCartItems = function() { return cartItems; };

  // Sync nav badge when Shopify cart drawer closes
  function syncCartBadge() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var badge = document.getElementById('cartBadge');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
  }
  var drawer = document.getElementById('aurum-cart-drawer');
  if (drawer) {
    var dialog = drawer.querySelector('dialog');
    if (dialog) {
      new MutationObserver(function() {
        if (!dialog.open) syncCartBadge();
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }
  }

  // Close cart panel on outside click (desktop only)
  document.addEventListener('click', function(e) {
    if (window.innerWidth <= 768) return;
    var panel = document.getElementById('cartPanel');
    var btn = document.getElementById('navCartBtn');
    if (panel && panel.style.display !== 'none') {
      if (!panel.contains(e.target) && (!btn || !btn.contains(e.target))) {
        panel.style.display = 'none';
      }
    }
  });
})();


// ══════════════════════════════════════════════
// ZÁKAZNÍCKA ZÓNA — Form Logic
// ══════════════════════════════════════════════
(function() {
  // State
  var selectedType = null;
  var selectedProduct = null;

  // ── Helper: Form ID from type ──
  function getFormId(t) {
    if (t === 'jednorazovy') return 'Jednorazovy';
    if (t === 'ppn') return 'PPN';
    if (t === 'registracia') return 'Registracia';
    return t;
  }

  // ── Hide all zone forms ──
  function hideAllForms() {
    ['formJednorazovy','formPPN','formRegistracia','confirmJednorazovy','confirmPPN','confirmRegistracia'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
    var dash = document.getElementById('loginDashboard');
    if (dash) dash.style.display = 'none';
  }

  // ── Type Selection (registracia / jednorazovy / ppn) ──
  window.zoneSelectType = function(type) {
    selectedType = type;
    var loginScreen = document.getElementById('zoneLoginScreen');
    if (loginScreen) loginScreen.style.display = 'none';
    var dash = document.getElementById('loginDashboard');
    if (dash) dash.style.display = 'none';
    hideAllForms();
    var formEl = document.getElementById('form' + getFormId(type));
    if (formEl) formEl.style.display = 'block';
    zoneGoToStep(type, 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Show form from dashboard (for logged-in users) ──
  window.zoneShowForm = function(type) {
    selectedType = type;
    var dash = document.getElementById('loginDashboard');
    if (dash) dash.style.display = 'none';
    hideAllForms();
    var formEl = document.getElementById('form' + getFormId(type));
    if (formEl) formEl.style.display = 'block';
    // Pre-fill form with customer data if available
    prefillFormFromDashboard(type);
    zoneGoToStep(type, 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Pre-fill form fields from dashboard data (logged-in user) ──
  function prefillFormFromDashboard(formType) {
    var prefix = formType === 'jednorazovy' ? 'jed' : formType === 'ppn' ? 'ppnForm' : '';
    if (!prefix) return;
    var fnameEl = document.getElementById('dash-customer-fname');
    var lnameEl = document.getElementById('dash-customer-lname');
    var emailEl = document.getElementById('dash-customer-email');
    // Pre-fill personal data
    var fn = document.getElementById(prefix + 'FirstName');
    var ln = document.getElementById(prefix + 'LastName');
    var em = document.getElementById(prefix + 'Email');
    if (fn && fnameEl) fn.value = fnameEl.value || '';
    if (ln && lnameEl) ln.value = lnameEl.value || '';
    if (em && emailEl) em.value = emailEl.value || '';
    // Pre-fill contact data from dashboard inputs if available
    var ph = document.getElementById(prefix + 'Phone');
    var dashPhone = document.getElementById('dashContactPhone');
    if (ph && dashPhone && dashPhone.value) ph.value = dashPhone.value;
  }

  // ── Back to Choice/Dashboard Screen ──
  window.zoneBackToChoice = function(formType) {
    hideAllForms();
    // If customer is logged in, go back to dashboard; otherwise show login screen
    var customerEl = document.getElementById('dash-customer-id');
    if (customerEl && customerEl.value) {
      var dash = document.getElementById('loginDashboard');
      if (dash) dash.style.display = 'block';
      dashSwitchTab('prehled');
    } else {
      var loginScreen = document.getElementById('zoneLoginScreen');
      if (loginScreen) loginScreen.style.display = 'block';
    }
    selectedType = null;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Step Navigation ──
  function zoneGoToStep(formType, step) {
    var formId = getFormId(formType);
    var stepsContainer = document.getElementById('steps' + formId);
    var panels = document.querySelectorAll('.zone-form-panel[data-form="' + formType + '"]');

    if (!stepsContainer) return;

    // Update step indicators
    var stepItems = stepsContainer.querySelectorAll('.zone-step-item');
    var stepLines = stepsContainer.querySelectorAll('.zone-step-line');
    stepItems.forEach(function(item, i) {
      var s = i + 1;
      item.classList.remove('active', 'done');
      if (s === step) item.classList.add('active');
      else if (s < step) item.classList.add('done');
    });
    stepLines.forEach(function(line, i) {
      line.classList.toggle('done', (i + 1) < step);
    });

    // Show correct panel
    panels.forEach(function(p) {
      var ps = parseInt(p.getAttribute('data-step'));
      p.classList.toggle('active', ps === step);
    });
  }

  window.zoneNextStep = function(formType, currentStep) {
    // Update PPN summary on step 4→5
    if (formType === 'ppn' && currentStep === 4) {
      ppnUpdateSummaryFinal();
    }
    // Update Jednorazovy summary on step 3→4
    if (formType === 'jednorazovy' && currentStep === 3) {
      jednorazovoUpdateSummary();
    }
    zoneGoToStep(formType, currentStep + 1);
    var formIds = { jednorazovy: 'formJednorazovy', ppn: 'formPPN', registracia: 'formRegistracia' };
    var formEl = document.getElementById(formIds[formType]);
    if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  window.zonePrevStep = function(formType, currentStep) {
    zoneGoToStep(formType, currentStep - 1);
    var formIds = { jednorazovy: 'formJednorazovy', ppn: 'formPPN', registracia: 'formRegistracia' };
    var formEl = document.getElementById(formIds[formType]);
    if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // ── Product Selection (Jednorazový) ──
  var selectedVariantId = null;
  window.zoneToggleProduct = function(el) {
    document.querySelectorAll('#formJednorazovy .zone-product-option').forEach(function(o) {
      o.classList.remove('selected');
    });
    el.classList.add('selected');
    selectedProduct = el.querySelector('h5').textContent + ' — ' + el.querySelector('.prod-detail').textContent;
    // Capture Shopify variant ID for cart add
    selectedVariantId = el.getAttribute('data-variant-id') || null;

    var weight = el.querySelector('h5').textContent;
    var largeProducts = ['50g', '100g', '250g', '500g', '1 oz', '1/2 oz'];
    var amlWarn = document.getElementById('amlWarningJednorazovy');
    if (amlWarn) {
      amlWarn.style.display = largeProducts.indexOf(weight) >= 0 ? 'flex' : 'none';
    }
  };

  // ── Jednorazový Summary ──
  function jednorazovoUpdateSummary() {
    var prodEl = document.getElementById('summJProduct');
    var qtyEl = document.getElementById('summJQty');
    var delEl = document.getElementById('summJDelivery');

    if (prodEl) prodEl.textContent = selectedProduct || '—';

    var qtyInput = document.getElementById('jedQuantity');
    if (qtyEl && qtyInput) qtyEl.textContent = qtyInput.value;

    var delSelect = document.getElementById('jedDelivery');
    if (delEl && delSelect) {
      var opt = delSelect.options[delSelect.selectedIndex];
      delEl.textContent = opt && opt.value ? opt.text : '—';
    }
  }

  // ── PPN Summary Calculator ──
  window.ppnUpdateSummary = function() {
    var amount = parseInt(document.getElementById('ppnAmount').value) || 20;
    var durSelect = document.getElementById('ppnDuration');
    var duration = parseInt(durSelect.value) || 60;
    var durText = durSelect.options[durSelect.selectedIndex].text;

    if (amount < 20) amount = 20;
    if (amount > 100) {
      amount = Math.round(amount / 10) * 10;
    }

    var total = amount * duration;

    var sa = document.getElementById('ppnSummAmount');
    var sd = document.getElementById('ppnSummDuration');
    var st = document.getElementById('ppnSummTotal');
    if (sa) sa.innerHTML = '<em>' + amount.toLocaleString('sk-SK') + ' €</em>';
    if (sd) sd.textContent = durText;
    if (st) st.innerHTML = '<em>' + total.toLocaleString('sk-SK') + ' €</em>';
  };

  function ppnUpdateSummaryFinal() {
    var amount = parseInt(document.getElementById('ppnAmount').value) || 20;
    var durSelect = document.getElementById('ppnDuration');
    var duration = parseInt(durSelect.value) || 60;
    var total = amount * duration;

    var spa = document.getElementById('summPAmount');
    var spd = document.getElementById('summPDuration');
    var spt = document.getElementById('summPTotal');
    if (spa) spa.textContent = amount.toLocaleString('sk-SK') + ' €';
    if (spd) spd.textContent = duration + ' mesiacov';
    if (spt) spt.textContent = total.toLocaleString('sk-SK') + ' €';
  }

  // ── Submit (jednorazový / ppn / registrácia) ──
  window.zoneSubmit = function(formType) {
    // Determine form and last step
    var formIdMap = { jednorazovy: 'formJednorazovy', ppn: 'formPPN', registracia: 'formRegistracia' };
    var lastStepMap = { jednorazovy: '4', ppn: '5', registracia: '4' };
    var formId = formIdMap[formType] || 'formJednorazovy';
    var lastStep = lastStepMap[formType] || '4';

    var panel = document.querySelector('#' + formId + ' .zone-form-panel[data-step="' + lastStep + '"]');
    if (!panel) return;

    var checkboxes = panel.querySelectorAll('input[type="checkbox"][required]');
    var allChecked = true;
    checkboxes.forEach(function(cb) {
      if (!cb.checked) allChecked = false;
    });
    if (!allChecked) {
      alert('Prosím, potvrďte všetky povinné súhlasy označené hviezdičkou (*).');
      return;
    }

    // Route to form-specific submit handler
    if (formType === 'registracia') {
      zoneSubmitRegistracia();
      return;
    }
    if (formType === 'jednorazovy') {
      zoneSubmitJednorazovy();
      return;
    }
    if (formType === 'ppn') {
      zoneSubmitPPN();
      return;
    }

    // Hide everything
    hideAllForms();
    var loginScreen = document.getElementById('zoneLoginScreen');
    if (loginScreen) loginScreen.style.display = 'none';
    var dashEl = document.getElementById('loginDashboard');
    if (dashEl) dashEl.style.display = 'none';

    // Show appropriate confirmation screen
    var confirmId = 'confirm' + (formType === 'jednorazovy' ? 'Jednorazovy' : 'PPN');
    var confirmEl = document.getElementById(confirmId);

    // Populate confirmation data
    if (formType === 'jednorazovy') {
      var prodEl = document.getElementById('confirmJProduct');
      if (prodEl) prodEl.textContent = selectedProduct || '—';
    } else if (formType === 'ppn') {
      var amount = parseInt(document.getElementById('ppnAmount').value) || 20;
      var durSelect = document.getElementById('ppnDuration');
      var duration = parseInt(durSelect.value) || 60;
      var total = amount * duration;
      var pa = document.getElementById('confirmPAmount');
      var pd = document.getElementById('confirmPDuration');
      var pt = document.getElementById('confirmPTotal');
      var pp = document.getElementById('confirmPPayment');
      if (pa) pa.textContent = amount.toLocaleString('sk-SK') + ' €';
      if (pd) pd.textContent = duration + ' mesiacov (' + Math.round(duration/12) + ' rokov)';
      if (pt) pt.textContent = total.toLocaleString('sk-SK') + ' €';
      if (pp) pp.textContent = amount.toLocaleString('sk-SK') + ' €';
    }

    if (confirmEl) confirmEl.style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Registration Submit (real API call) ──
  async function zoneSubmitRegistracia() {
    var btn = document.getElementById('regSubmitBtn');
    var msg = document.getElementById('regSubmitMsg');

    // Collect form data
    var data = {
      title: (document.getElementById('regTitle') || {}).value || '',
      firstName: (document.getElementById('regFirstName') || {}).value || '',
      lastName: (document.getElementById('regLastName') || {}).value || '',
      birthDate: (document.getElementById('regBirthDate') || {}).value || '',
      nationality: (document.getElementById('regNationality') || {}).value || 'SK',
      street: (document.getElementById('regStreet') || {}).value || '',
      city: (document.getElementById('regCity') || {}).value || '',
      zip: (document.getElementById('regZip') || {}).value || '',
      country: (document.getElementById('regCountry') || {}).value || 'SK',
      email: (document.getElementById('regEmail') || {}).value || '',
      phone: (document.getElementById('regPhone') || {}).value || '',
      iban: (document.getElementById('regIban') || {}).value || '',
      bankName: (document.getElementById('regBankName') || {}).value || '',
      acceptsMarketing: document.getElementById('regMarketing') ? document.getElementById('regMarketing').checked : false
    };

    // Client-side validation
    if (!data.firstName || !data.lastName || !data.email || !data.phone || !data.street || !data.city || !data.zip || !data.iban) {
      if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Vyplňte všetky povinné polia.'; }
      return;
    }

    if (btn) { btn.disabled = true; btn.textContent = 'Odosielam...'; }
    if (msg) msg.style.display = 'none';

    try {
      var response = await fetch(AURUM_API_BASE + '/api/customer/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      var result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error || 'Registrácia zlyhala.');

      // Success — show confirmation screen
      hideAllForms();
      var loginScreen = document.getElementById('zoneLoginScreen');
      if (loginScreen) loginScreen.style.display = 'none';
      var dashEl = document.getElementById('loginDashboard');
      if (dashEl) dashEl.style.display = 'none';
      var confirmEl = document.getElementById('confirmRegistracia');
      if (confirmEl) confirmEl.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      var errorMsg = (err && err.message) ? err.message : 'Nepodarilo sa vytvoriť účet. Skúste to znova.';
      if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = errorMsg; }
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = 'Vytvoriť účet'; }
    }
  }

  // ── Jednorazový Submit (real API call) ──
  async function zoneSubmitJednorazovy() {
    var btn = document.getElementById('jedSubmitBtn');
    var msg = document.getElementById('jedSubmitMsg');

    // Check if logged in
    var customerIdEl = document.getElementById('dash-customer-id');
    var customerEmailEl = document.getElementById('dash-customer-email');
    var isLoggedIn = customerIdEl && customerIdEl.value;

    var data = {
      // Customer identity (if logged in)
      customerId: isLoggedIn ? customerIdEl.value : '',
      customerEmail: isLoggedIn ? (customerEmailEl || {}).value : '',
      // Personal data from form
      title: (document.getElementById('jedTitle') || {}).value || '',
      firstName: (document.getElementById('jedFirstName') || {}).value || '',
      lastName: (document.getElementById('jedLastName') || {}).value || '',
      birthDate: (document.getElementById('jedBirthDate') || {}).value || '',
      nationality: (document.getElementById('jedNationality') || {}).value || 'SK',
      street: (document.getElementById('jedStreet') || {}).value || '',
      city: (document.getElementById('jedCity') || {}).value || '',
      zip: (document.getElementById('jedZip') || {}).value || '',
      country: (document.getElementById('jedCountry') || {}).value || 'SK',
      email: (document.getElementById('jedEmail') || {}).value || '',
      phone: (document.getElementById('jedPhone') || {}).value || '',
      iban: (document.getElementById('jedIban') || {}).value || '',
      bankName: (document.getElementById('jedBankName') || {}).value || '',
      // Order data
      product: selectedProduct || '',
      quantity: (document.getElementById('jedQuantity') || {}).value || '1',
      delivery: (document.getElementById('jedDelivery') || {}).value || ''
    };

    if (!data.firstName || !data.lastName || !data.product || !data.delivery || !data.iban) {
      if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Vyplňte všetky povinné polia a vyberte produkt.'; }
      return;
    }

    if (msg) msg.style.display = 'none';

    // PRIMARY PATH: Add to Shopify cart and redirect to checkout
    // (Shopify handles payment, our webhook creates the OneTimeOrder)
    if (selectedVariantId) {
      if (btn) { btn.disabled = true; btn.textContent = 'Pridávam do košíka...'; }
      try {
        // Clear cart first to avoid mixing
        await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });

        // Add product with delivery method as line item property
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(selectedVariantId, 10),
            quantity: parseInt(data.quantity, 10) || 1,
            properties: {
              'Spôsob doručenia': data.delivery,
              'IBAN': data.iban,
              'Meno': data.firstName + ' ' + data.lastName
            }
          })
        });
        if (!addRes.ok) throw new Error('Nepodarilo sa pridať produkt do košíka');

        // Redirect to Shopify checkout — order-paid webhook handles the rest
        window.location.href = '/checkout';
      } catch (err) {
        var errorMsg = (err && err.message) ? err.message : 'Nepodarilo sa pridať produkt do košíka.';
        if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = errorMsg; }
        if (btn) { btn.disabled = false; btn.textContent = 'Odoslať záväznú objednávku'; }
      }
      return;
    }

    // FALLBACK: Legacy API POST (used only if Shopify variant ID not available)
    if (btn) { btn.disabled = true; btn.textContent = 'Odosielam...'; }
    try {
      var response = await fetch(AURUM_API_BASE + '/api/customer/one-time-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      var result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error || 'Objednávka zlyhala.');

      // Populate confirmation with VS from API
      var vsEl = document.getElementById('confirmJVS');
      if (vsEl && result.variableSymbol) vsEl.textContent = result.variableSymbol;

      // Show confirmation screen
      hideAllForms();
      var loginScreen = document.getElementById('zoneLoginScreen');
      if (loginScreen) loginScreen.style.display = 'none';
      var dashEl = document.getElementById('loginDashboard');
      if (dashEl) dashEl.style.display = 'none';

      var prodEl = document.getElementById('confirmJProduct');
      if (prodEl) prodEl.textContent = selectedProduct || '—';

      var confirmEl = document.getElementById('confirmJednorazovy');
      if (confirmEl) confirmEl.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      var errorMsg = (err && err.message) ? err.message : 'Nepodarilo sa odoslať objednávku.';
      if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = errorMsg; }
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = 'Odoslať záväznú objednávku'; }
    }
  }

  // ── PPN Submit (real API call) ──
  async function zoneSubmitPPN() {
    var btn = document.getElementById('ppnSubmitBtn');
    var msg = document.getElementById('ppnSubmitMsg');

    // Check if logged in
    var customerIdEl = document.getElementById('dash-customer-id');
    var customerEmailEl = document.getElementById('dash-customer-email');
    var isLoggedIn = customerIdEl && customerIdEl.value;

    var data = {
      // Customer identity (if logged in)
      customerId: isLoggedIn ? customerIdEl.value : '',
      customerEmail: isLoggedIn ? (customerEmailEl || {}).value : '',
      // Personal data
      title: (document.getElementById('ppnFormTitle') || {}).value || '',
      firstName: (document.getElementById('ppnFormFirstName') || {}).value || '',
      lastName: (document.getElementById('ppnFormLastName') || {}).value || '',
      birthDate: (document.getElementById('ppnFormBirthDate') || {}).value || '',
      nationality: (document.getElementById('ppnFormNationality') || {}).value || 'SK',
      // Contact
      street: (document.getElementById('ppnFormStreet') || {}).value || '',
      city: (document.getElementById('ppnFormCity') || {}).value || '',
      zip: (document.getElementById('ppnFormZip') || {}).value || '',
      country: (document.getElementById('ppnFormCountry') || {}).value || 'SK',
      email: (document.getElementById('ppnFormEmail') || {}).value || '',
      phone: (document.getElementById('ppnFormPhone') || {}).value || '',
      // Bank
      iban: (document.getElementById('ppnFormIban') || {}).value || '',
      bankName: (document.getElementById('ppnFormBankName') || {}).value || '',
      swift: (document.getElementById('ppnFormSwift') || {}).value || '',
      currency: (document.getElementById('ppnFormCurrency') || {}).value || 'EUR',
      // Plan config
      monthlyAmount: (document.getElementById('ppnAmount') || {}).value || '20',
      durationMonths: (document.getElementById('ppnDuration') || {}).value || '60',
      // Marketing
      acceptsMarketing: document.getElementById('ppnFormMarketing') ? document.getElementById('ppnFormMarketing').checked : false
    };

    if (!data.firstName || !data.lastName || !data.email || !data.iban) {
      if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Vyplňte všetky povinné polia.'; }
      return;
    }

    if (btn) { btn.disabled = true; btn.textContent = 'Odosielam...'; }
    if (msg) msg.style.display = 'none';

    try {
      var response = await fetch(AURUM_API_BASE + '/api/customer/create-plan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      var result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error || 'Uzatvorenie zmluvy zlyhalo.');

      // Populate confirmation with data from API
      var amount = parseInt(data.monthlyAmount) || 20;
      var duration = parseInt(data.durationMonths) || 60;
      var total = amount * duration;

      var pa = document.getElementById('confirmPAmount');
      var pd = document.getElementById('confirmPDuration');
      var pt = document.getElementById('confirmPTotal');
      var pp = document.getElementById('confirmPPayment');
      if (pa) pa.textContent = amount.toLocaleString('sk-SK') + ' \u20ac';
      if (pd) pd.textContent = duration + ' mesiacov (' + Math.round(duration / 12) + ' rokov)';
      if (pt) pt.textContent = total.toLocaleString('sk-SK') + ' \u20ac';
      if (pp) pp.textContent = amount.toLocaleString('sk-SK') + ' \u20ac';

      // Show confirmation screen
      hideAllForms();
      var loginScreen = document.getElementById('zoneLoginScreen');
      if (loginScreen) loginScreen.style.display = 'none';
      var dashEl = document.getElementById('loginDashboard');
      if (dashEl) dashEl.style.display = 'none';

      var confirmEl = document.getElementById('confirmPPN');
      if (confirmEl) confirmEl.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      var errorMsg = (err && err.message) ? err.message : 'Nepodarilo sa uzatvoriť zmluvu.';
      if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = errorMsg; }
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = 'Uzatvoriť zmluvu a odoslať'; }
    }
  }

  // ── Restart (back to dashboard or login screen from confirmation) ──
  window.zoneRestart = function() {
    ['confirmJednorazovy','confirmPPN','confirmRegistracia'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
    hideAllForms();
    var customerEl = document.getElementById('dash-customer-id');
    if (customerEl && customerEl.value) {
      var dash = document.getElementById('loginDashboard');
      if (dash) dash.style.display = 'block';
      dashSwitchTab('prehled');
    } else {
      var loginScreen = document.getElementById('zoneLoginScreen');
      if (loginScreen) loginScreen.style.display = 'block';
    }
    selectedType = null;
    selectedProduct = null;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
})();

// ══════════════════════════════════════════════
// DASHBOARD — Tab Switching
// ══════════════════════════════════════════════
window.dashSwitchTab = function(tabName) {
  var dashboard = document.getElementById('loginDashboard');
  if (!dashboard) return;
  // Update tab buttons
  dashboard.querySelectorAll('.dash-tab').forEach(function(tab) {
    tab.classList.remove('active');
    if (tab.getAttribute('onclick') && tab.getAttribute('onclick').indexOf("'" + tabName + "'") >= 0) {
      tab.classList.add('active');
    }
  });
  // Update tab panels
  dashboard.querySelectorAll('.dash-tab-panel').forEach(function(panel) {
    panel.classList.remove('active');
    if (panel.getAttribute('data-tab') === tabName) {
      panel.classList.add('active');
    }
  });

  // Load data for specific tabs on activation
  if (tabName === 'objednavky') {
    dashLoadOneTimeOrders();
  }
};

// ══════════════════════════════════════════════
// DASHBOARD — Load Real Data from API
// ══════════════════════════════════════════════
var AURUM_API_BASE = 'https://aurum-api.vercel.app';

function dashFormatEur(num) {
  if (num == null || isNaN(num)) return '0,00 \u20ac';
  return num.toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0\u20ac';
}

function dashFormatGrams(num, decimals) {
  if (num == null || isNaN(num)) return '0\u00a0g';
  decimals = decimals || 6;
  var short = num.toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var full = num.toLocaleString('sk-SK', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  return '<span class="g-full">' + full + '\u00a0g</span><span class="g-short">' + short + '\u00a0g</span>';
}

function dashFormatDate(isoDate) {
  if (!isoDate) return '-';
  var d = new Date(isoDate);
  if (isNaN(d.getTime())) return '-';
  return String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0') + '.' + d.getFullYear();
}

function dashSetText(id, text) {
  var el = document.getElementById(id);
  if (el) {
    if (el.tagName === 'INPUT' || el.tagName === 'SELECT') {
      el.value = text || '';
    } else {
      el.textContent = text || '';
    }
  }
}

window.dashLoadData = async function() {
  var customerIdEl = document.getElementById('dash-customer-id');
  if (!customerIdEl || !customerIdEl.value) return;

  try {
    var response = await fetch(AURUM_API_BASE + '/api/customer/dashboard?customerId=' + encodeURIComponent(customerIdEl.value));
    if (!response.ok) throw new Error('API error: ' + response.status);
    var data = await response.json();
    if (!data.success) throw new Error(data.error || 'Unknown error');

    dashPopulateHeader(data);
    dashPopulateSummaryCards(data);
    dashPopulateContract(data);
    dashPopulateTransactions(data);
    dashPopulatePayments(data);
    dashPopulatePersonalData(data);

    // Load one-time gold orders (separate API call)
    dashLoadOneTimeOrders();
  } catch (err) {
    console.error('[AURUM Dashboard] Data load failed:', err);
    var msg = '<tr><td colspan="5" style="text-align:center;color:var(--gray);">Nepodarilo sa na\u010d\u00edta\u0165 \u00fadaje</td></tr>';
    var tb1 = document.getElementById('dashTransactionsBody');
    if (tb1) tb1.innerHTML = msg;
    var tb2 = document.getElementById('dashPaymentsBody');
    if (tb2) tb2.innerHTML = msg;
  }
};

function dashPopulateHeader(data) {
  var c = data.customer || {};
  var fname = c.firstName || (document.getElementById('dash-customer-fname') || {}).value || '';
  dashSetText('dashUserName', 'Vitajte sp\u00e4\u0165' + (fname ? ', ' + fname : ''));
  dashSetText('dashUserEmail', c.email || '');
  dashSetText('dashContractNum', c.contractNumber || '-');
  dashSetText('dashClientSince', c.clientSince || '-');
}

function dashPopulateSummaryCards(data) {
  var pos = data.position || {};
  var totalGrams = pos.totalGrams || 0;

  var tgEl = document.getElementById('dashTotalGrams');
  if (tgEl) tgEl.innerHTML = dashFormatGrams(totalGrams, 6);
  dashSetText('dashTroyOz', '\u2248 ' + (totalGrams / 31.1035).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' tr\u00f3jskej unce');
  dashSetText('dashCurrentValue', dashFormatEur(pos.currentValue));
  dashSetText('dashGoldPrice', data.currentGoldPrice ? 'LBMA PM: ' + data.currentGoldPrice.toLocaleString('sk-SK', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' \u20ac/g' : '-');
  dashSetText('dashTotalInvested', dashFormatEur(pos.totalInvested));

  var plan = data.plan;
  var total = plan ? plan.durationMonths : 0;
  var count = data.paymentCount || 0;
  dashSetText('dashPaymentCount', count + (total ? ' z ' + total + ' platieb' : ' platieb'));

  if (plan && plan.monthlyPayment) {
    dashSetText('dashNextPayment', dashFormatEur(plan.monthlyPayment));
    var now = new Date();
    var eom = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    dashSetText('dashNextPaymentDate', 'do ' + dashFormatDate(eom.toISOString()));
  } else {
    dashSetText('dashNextPayment', '-');
    dashSetText('dashNextPaymentDate', '-');
  }
}

function dashPopulateContract(data) {
  var c = data.customer || {};
  var plan = data.plan;

  dashSetText('dashContractLabel', 'Zmluva ' + (c.contractNumber || '-'));
  dashSetText('dashContractVS', c.variableSymbol || '-');

  if (plan) {
    var labels = { 'SUBSCRIPTION': 'PPN \u2014 Program pravideln\u00e9ho n\u00e1kupu', 'RENTA': 'Renta \u2014 Pravideln\u00e9 vypl\u00e1canie', 'ONE_TIME': 'Jednorazov\u00fd n\u00e1kup' };
    dashSetText('dashContractType', labels[plan.type] || plan.type || '-');
    dashSetText('dashMonthlyPayment', dashFormatEur(plan.monthlyPayment));
    dashSetText('dashDuration', (plan.durationMonths || 0) + ' mesiacov');

    if (plan.startDate && plan.endDate) {
      var sd = new Date(plan.startDate);
      var ed = new Date(plan.endDate);
      dashSetText('dashPeriod', String(sd.getMonth()+1).padStart(2,'0') + '/' + sd.getFullYear() + ' \u2014 ' + String(ed.getMonth()+1).padStart(2,'0') + '/' + ed.getFullYear());
    } else {
      dashSetText('dashPeriod', '-');
    }

    dashSetText('dashTotalGoal', dashFormatEur(plan.totalGoal));
    var pos = data.position || {};
    dashSetText('dashContractStatus', pos.accountFrozen ? 'Zmrazen\u00e1' : 'Akt\u00edvna');
    var sEl = document.getElementById('dashContractStatus');
    if (sEl) sEl.style.color = pos.accountFrozen ? '#e74c3c' : '#2ecc71';

    var cnt = data.paymentCount || 0;
    var tot = plan.durationMonths || 1;
    var pct = Math.min(100, Math.round((cnt / tot) * 1000) / 10);
    var lbl = document.getElementById('dashProgressLabel');
    if (lbl) lbl.innerHTML = '<span>Splnen\u00e9: ' + cnt + ' / ' + tot + ' platieb</span><span>' + pct.toLocaleString('sk-SK',{minimumFractionDigits:1,maximumFractionDigits:1}) + ' %</span>';
    var fill = document.getElementById('dashProgressFill');
    if (fill) fill.style.width = pct + '%';
  } else {
    dashSetText('dashContractType', 'Zatia\u013e \u017eiadna akt\u00edvna zmluva');
    ['dashMonthlyPayment','dashDuration','dashPeriod','dashTotalGoal','dashContractStatus'].forEach(function(id) { dashSetText(id, '-'); });
  }

  var bank = data.companyBank || {};
  dashSetText('dashBankAccount', bank.iban || '-');
  dashSetText('dashCompanyName', bank.name || '-');
  dashSetText('dashCompanyIban', bank.iban || '-');
  dashSetText('dashCompanyBankName', bank.bankName || '-');
  // Populate confirmation screens' company bank details (class-based, multiple elements)
  document.querySelectorAll('.confirmCompanyName').forEach(function(el) { el.textContent = bank.name || '-'; });
  document.querySelectorAll('.confirmCompanyIban').forEach(function(el) { el.textContent = bank.iban || '-'; });
  document.querySelectorAll('.confirmCompanyBank').forEach(function(el) { el.textContent = bank.bankName || '-'; });
  dashSetText('dashPaymentVS', c.variableSymbol || '-');
  dashSetText('dashPaymentAmount', plan && plan.monthlyPayment ? dashFormatEur(plan.monthlyPayment) : '-');

  // Document section
  var contractLabel = c.contractNumber || '-';
  var planLabel = plan ? (plan.type === 'RENTA' ? 'Renta' : plan.type === 'SUBSCRIPTION' ? 'PPN' : 'Jednorazov\u00fd n\u00e1kup') : '';
  dashSetText('dashDocContractName', 'Zmluva ' + contractLabel + (planLabel ? ' \u2014 ' + planLabel : ''));
  if (plan && plan.startDate) {
    dashSetText('dashDocContractDate', 'PDF \u00b7 Podp\u00edsan\u00e1 ' + dashFormatDate(plan.startDate));
  } else {
    dashSetText('dashDocContractDate', 'PDF');
  }
}

function dashPopulateTransactions(data) {
  var tbody = document.getElementById('dashTransactionsBody');
  if (!tbody) return;
  var txs = (data.transactions || []).filter(function(t) { return t.type === 'PURCHASE'; });
  if (txs.length === 0) {
    tbody.innerHTML = '<tr><td colspan="5" style="text-align:center;color:var(--gray);">Zatia\u013e \u017eiadne transakcie</td></tr>';
    return;
  }
  var html = '';
  txs.slice(0, 10).forEach(function(t) {
    html += '<tr><td>' + dashFormatDate(t.date) + '</td>';
    html += '<td>' + dashFormatEur(t.eurPaid) + '</td>';
    html += '<td>' + (t.goldPrice ? t.goldPrice.toLocaleString('sk-SK',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' \u20ac' : '-') + '</td>';
    html += '<td class="td-gold">' + dashFormatGrams(t.gramsAdded, 6) + '</td>';
    html += '<td>' + dashFormatGrams(t.gramsBalance, 6) + '</td></tr>';
  });
  tbody.innerHTML = html;
}

function dashPopulatePayments(data) {
  var tbody = document.getElementById('dashPaymentsBody');
  if (!tbody) return;
  var txs = data.transactions || [];
  var vs = (data.customer || {}).variableSymbol || '-';
  if (txs.length === 0) {
    tbody.innerHTML = '<tr><td colspan="5" style="text-align:center;color:var(--gray);">Zatia\u013e \u017eiadne platby</td></tr>';
    return;
  }
  var html = '';
  txs.slice(0, 20).forEach(function(t) {
    var lbl = 'Mesa\u010dn\u00e1 platba';
    if (t.type === 'FEE_INACTIVITY') lbl = 'Poplatok za ne\u010dinnos\u0165';
    else if (t.type === 'FEE_TERMINATION') lbl = 'Poplatok za ukon\u010denie';
    else if (t.type === 'RENTA_SELL') lbl = 'Renta v\u00fdplata';
    else if (t.subscriptionType === 'ONE_TIME') lbl = 'Jednorazov\u00fd n\u00e1kup';
    var cls = t.type === 'PURCHASE' ? 'status-ok' : 'status-warn';
    var sLbl = t.type === 'PURCHASE' ? 'Prep\u00edsan\u00e1' : lbl;
    html += '<tr><td>' + dashFormatDate(t.date) + '</td>';
    html += '<td>' + lbl + '</td>';
    html += '<td class="td-gold">' + dashFormatEur(Math.abs(t.eurPaid || 0)) + '</td>';
    html += '<td>' + vs + '</td>';
    html += '<td><span class="status-badge ' + cls + '">' + sLbl + '</span></td></tr>';
  });
  tbody.innerHTML = html;
}

function dashPopulatePersonalData(data) {
  var c = data.customer || {};
  dashSetText('dashContactEmail', c.email);
  dashSetText('dashContactPhone', c.phone);
  dashSetText('dashContactAddress', c.correspondenceAddress || c.address);
  dashSetText('dashContactCity', c.city);
  dashSetText('dashContactZip', c.zip);
  var sel = document.getElementById('dashContactCountry');
  if (sel && c.country) sel.value = c.country;

  dashSetText('dashContractName', ((c.firstName || '') + ' ' + (c.lastName || '')).trim());
  dashSetText('dashContractBirthDate', c.birthDate || '-');
  dashSetText('dashContractPermanentAddress', c.permanentAddress || '-');
  var nationalities = {'SK':'Slovensk\u00e1 republika','CZ':'\u010cesk\u00e1 republika'};
  dashSetText('dashContractNationality', nationalities[c.country] || c.country || '-');
  dashSetText('dashContractIban', c.iban || '-');

  var bankName = '-';
  if (c.iban) {
    var code = c.iban.replace(/\s/g, '').substring(4, 8);
    var banks = {'0900':'Slovensk\u00e1 sporite\u013e\u0148a','1100':'Tatra banka','0200':'V\u00daBanka','5600':'Prima banka','3100':'Prima banka','6500':'Po\u0161tov\u00e1 banka','8330':'Fio banka'};
    bankName = banks[code] || 'Banka (' + code + ')';
  }
  dashSetText('dashContractBank', bankName);
}

// ══════════════════════════════════════════════
// DASHBOARD — One-Time Gold Orders
// ══════════════════════════════════════════════

var OTO_STATUS = {
  CREATED: { label: 'Čaká na platbu', cls: 'status-warn' },
  PAID: { label: 'Uhradená', cls: 'status-info' },
  VERIFIED: { label: 'Overená', cls: 'status-info' },
  PURCHASED: { label: 'Nakúpená', cls: 'status-warn' },
  SETTLED: { label: 'Vyúčtovaná', cls: 'status-ok' },
  SHIPPED: { label: 'Odoslaná', cls: 'status-ok' },
  COMPLETED: { label: 'Dokončená', cls: 'status-ok' },
  CANCELLED: { label: 'Stornovaná', cls: 'status-err' },
  EXPIRED: { label: 'Expirovaná', cls: 'status-err' }
};

async function dashLoadOneTimeOrders() {
  var customerIdEl = document.getElementById('dash-customer-id');
  if (!customerIdEl || !customerIdEl.value) return;

  var listEl = document.getElementById('dashOrdersList');
  var emptyEl = document.getElementById('dashOrdersEmpty');
  if (!listEl) return;

  try {
    var response = await fetch(AURUM_API_BASE + '/api/customer/one-time-order?customerId=' + encodeURIComponent(customerIdEl.value));
    if (!response.ok) throw new Error('API error');
    var data = await response.json();

    if (!data.success || !data.orders || data.orders.length === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      listEl.innerHTML = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    dashPopulateOrders(data.orders, listEl);
  } catch (err) {
    console.error('[AURUM] One-time orders load failed:', err);
    listEl.innerHTML = '<p style="color:var(--gray);text-align:center;">Nepodarilo sa načítať objednávky.</p>';
  }
}

function dashPopulateOrders(orders, container) {
  var html = '';
  orders.forEach(function(o) {
    var st = OTO_STATUS[o.status] || { label: o.status, cls: '' };
    var items = (o.items || []).map(function(i) {
      return i.productTitle + ' ×' + i.quantity;
    }).join(', ');
    var paid = o.pricing && o.pricing.paidTotalEur ? dashFormatEur(o.pricing.paidTotalEur) : '—';
    var finalP = o.pricing && o.pricing.finalTotalEur ? dashFormatEur(o.pricing.finalTotalEur) : '—';
    var date = o.createdAt ? dashFormatDate(o.createdAt) : '—';
    var orderName = o.shopifyOrderName || (o.shopifyOrderId ? '#' + o.shopifyOrderId : 'VS ' + (o.variableSymbol || o.id));

    // Settlement info
    var settlementHtml = '';
    if (o.pricing && o.pricing.settlementType === 'DOPLATOK' && o.doplatok) {
      if (o.doplatok.paid) {
        settlementHtml = '<div style="color:#4caf50;font-size:0.75rem;">Doplatok uhradený: ' + dashFormatEur(o.doplatok.amount) + '</div>';
      } else if (o.doplatok.invoiceUrl) {
        settlementHtml = '<a href="' + o.doplatok.invoiceUrl + '" class="zone-btn-submit" style="font-size:0.75rem;padding:0.3rem 0.8rem;display:inline-block;margin-top:0.3rem;">Zaplatiť doplatok: ' + dashFormatEur(o.doplatok.amount) + '</a>';
      } else {
        settlementHtml = '<div style="color:#ff9800;font-size:0.75rem;">Doplatok: ' + dashFormatEur(o.doplatok.amount) + '</div>';
      }
    } else if (o.pricing && o.pricing.settlementType === 'PREPLATOK' && o.preplatok) {
      if (o.preplatok.refunded) {
        settlementHtml = '<div style="color:#4caf50;font-size:0.75rem;">Preplatok vrátený: ' + dashFormatEur(o.preplatok.amount) + '</div>';
      } else {
        settlementHtml = '<div style="color:#2196f3;font-size:0.75rem;">Preplatok sa spracováva: ' + dashFormatEur(o.preplatok.amount) + '</div>';
      }
    }

    // Tracking info
    var trackingHtml = '';
    if (o.fulfillment && o.fulfillment.trackingNumber) {
      trackingHtml = '<div style="font-size:0.75rem;color:var(--gray);">Tracking: ' + o.fulfillment.trackingNumber + '</div>';
    }

    html += '<div class="dash-contract-box" style="margin-bottom:1rem;">';
    html += '<div class="dash-contract-detail-grid">';
    html += '<div class="detail-item"><h6>Objednávka</h6><div>' + orderName + '</div></div>';
    html += '<div class="detail-item"><h6>Dátum</h6><div>' + date + '</div></div>';
    html += '<div class="detail-item"><h6>Produkty</h6><div style="font-size:0.8rem;">' + items + '</div></div>';
    html += '<div class="detail-item"><h6>Záloha</h6><div>' + paid + '</div></div>';
    html += '<div class="detail-item"><h6>Finálna cena</h6><div>' + finalP + '</div></div>';
    html += '<div class="detail-item"><h6>Stav</h6><div><span class="status-badge ' + st.cls + '">' + st.label + '</span></div></div>';
    html += '</div>';
    if (settlementHtml) html += '<div style="padding:0.5rem 0 0;">' + settlementHtml + '</div>';
    if (trackingHtml) html += trackingHtml;
    html += '</div>';
  });

  container.innerHTML = html;
}

// ══════════════════════════════════════════════
// DASHBOARD — Save Contact Data
// ══════════════════════════════════════════════
window.dashSaveContact = async function() {
  var btn = document.getElementById('dashSaveContactBtn');
  var msg = document.getElementById('dashSaveContactMsg');
  var customerIdEl = document.getElementById('dash-customer-id');
  var emailEl = document.getElementById('dash-customer-email');

  if (!customerIdEl || !customerIdEl.value || !emailEl || !emailEl.value) {
    if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Chyba: nie ste prihlásený.'; }
    return;
  }

  if (btn) { btn.disabled = true; btn.textContent = 'Ukladám...'; }
  if (msg) msg.style.display = 'none';

  try {
    var response = await fetch(AURUM_API_BASE + '/api/customer/update-contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: customerIdEl.value,
        email: emailEl.value,
        phone: (document.getElementById('dashContactPhone') || {}).value || '',
        address: (document.getElementById('dashContactAddress') || {}).value || '',
        city: (document.getElementById('dashContactCity') || {}).value || '',
        zip: (document.getElementById('dashContactZip') || {}).value || '',
        country: (document.getElementById('dashContactCountry') || {}).value || 'SK'
      })
    });
    var data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.error || 'Nepodarilo sa uložiť');
    if (msg) { msg.style.display = 'block'; msg.style.color = '#2ecc71'; msg.textContent = 'Kontaktné údaje boli aktualizované.'; }
  } catch (err) {
    console.error('[AURUM] Contact save failed:', err);
    if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Chyba pri ukladaní. Skúste to znova.'; }
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = 'Uložiť zmeny'; }
    setTimeout(function() { if (msg) msg.style.display = 'none'; }, 5000);
  }
};

// Auto-load dashboard if customer is logged in via Shopify
// ══════════════════════════════════════════════
// DASHBOARD — Request Modal (Pokyny)
// ══════════════════════════════════════════════
var currentRequestType = '';

var requestConfig = {
  GOLD_DELIVERY: {
    title: 'Výdaj a doručenie zlata',
    desc: 'Požiadajte o fyzické doručenie nakúpeného zlata. Minimálna hmotnosť pre doručenie je 10 g.',
    fields: '<div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Spôsob doručenia <span style="color:var(--gold);">*</span></label><select id="reqDeliveryMethod" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"><option value="">Vyberte...</option><option value="postal">Cenná zásielka (poštou)</option><option value="parcel">Obchodný balík</option><option value="vehicle">Zberné vozidlo (iba SR)</option><option value="pickup">Osobný odber — Košice</option></select></div><div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Poznámka</label><textarea id="reqNote" rows="3" placeholder="Voliteľná poznámka k pokynu..." style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);resize:vertical;"></textarea></div>'
  },
  BUYBACK: {
    title: 'Jednorazový odkúp',
    desc: 'Požiadajte o spätný odkúp celého alebo časti investičného kovu. Aktuálna kúpna cena vám bude oznámená po obdržaní žiadosti.',
    fields: '<div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Počet gramov na odkúp <span style="color:var(--gold);">*</span></label><input type="number" id="reqGrams" min="0.1" step="0.001" placeholder="napr. 5.000" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"></div><div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Poznámka</label><textarea id="reqNote" rows="3" placeholder="Voliteľná poznámka..." style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);resize:vertical;"></textarea></div>'
  },
  RENTA: {
    title: 'Nastavenie renty',
    desc: 'Renta = pravidelný spätný odkúp zlata z hmotnostného fondu. Môžete si zvoliť mesačnú sumu v \u20ac alebo v gramoch.',
    fields: '<div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Typ renty <span style="color:var(--gold);">*</span></label><select id="reqRentaType" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"><option value="">Vyberte...</option><option value="EUR">Mesačná suma v \u20ac</option><option value="GRAMS">Mesačná suma v gramoch</option></select></div><div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Výška renty <span style="color:var(--gold);">*</span></label><input type="number" id="reqRentaAmount" min="1" step="0.01" placeholder="napr. 50" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"></div>'
  },
  EXTEND_PPN: {
    title: 'Predl\u017eenie PPN',
    desc: 'Predl\u017ete program pravideln\u00e9ho n\u00e1kupu. Pred\u013a\u017eenie mus\u00ed trva\u0165 min. 12 mesiacov. Suma nesmie by\u0165 ni\u017e\u0161ia ako v p\u00f4vodnom programe.',
    fields: '<div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Po\u010det mesiacov pred\u013a\u017eenia <span style="color:var(--gold);">*</span></label><select id="reqExtensionMonths" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"><option value="12">12 mesiacov (1 rok)</option><option value="24">24 mesiacov (2 roky)</option><option value="36">36 mesiacov (3 roky)</option><option value="48">48 mesiacov (4 roky)</option><option value="60">60 mesiacov (5 rokov)</option></select></div>'
  },
  EXTRA_DEPOSIT: {
    title: 'Dodato\u010dn\u00fd vklad',
    desc: 'Dodato\u010dn\u00fd vklad nem\u00e1 vplyv na v\u00e1\u0161 z\u00e1v\u00e4zok dodr\u017ea\u0165 dohodnut\u00fd PPN. Sta\u010d\u00ed uhradi\u0165 sumu nad dohodnut\u00fa mesa\u010dn\u00fa platbu na rovnak\u00fd \u00fa\u010det s rovnak\u00fdm VS.',
    fields: '<div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Suma dodato\u010dn\u00e9ho vkladu (\u20ac) <span style="color:var(--gold);">*</span></label><input type="number" id="reqExtraAmount" min="1" step="1" placeholder="napr. 100" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"></div>'
  },
  DISPONENT: {
    title: 'Spr\u00e1va disponenta',
    desc: 'Disponent je fyzick\u00e1 osoba opr\u00e1vnen\u00e1 vstupova\u0165 do v\u00e1\u0161ho \u00fa\u010dtu. M\u00f4\u017eete ho kedyko\u013evek zmeni\u0165 alebo odvola\u0165.',
    fields: '<div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Meno disponenta <span style="color:var(--gold);">*</span></label><input type="text" id="reqDisponentName" placeholder="Meno a priezvisko" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"></div><div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">E-mail disponenta <span style="color:var(--gold);">*</span></label><input type="email" id="reqDisponentEmail" placeholder="email@example.com" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"></div><div class="zone-field" style="margin-bottom:1rem;"><label style="display:block;margin-bottom:0.4rem;font-size:0.85rem;color:var(--white-muted);">Akcia</label><select id="reqDisponentAction" style="width:100%;padding:0.6rem;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:0.5rem;color:var(--white);"><option value="ADD">Ustanovi\u0165 disponenta</option><option value="CHANGE">Zmeni\u0165 disponenta</option><option value="REVOKE">Odvola\u0165 disponenta</option></select></div>'
  }
};

window.dashOpenRequest = function(type) {
  var config = requestConfig[type];
  if (!config) return;

  currentRequestType = type;
  var modal = document.getElementById('requestModal');
  document.getElementById('reqModalTitle').textContent = config.title;
  document.getElementById('reqModalDesc').textContent = config.desc;
  document.getElementById('reqModalFields').innerHTML = config.fields;
  var msgEl = document.getElementById('reqModalMsg');
  if (msgEl) msgEl.style.display = 'none';
  var btn = document.getElementById('reqModalBtn');
  if (btn) { btn.disabled = false; btn.textContent = 'Odosla\u0165 pokyn'; }
  modal.style.display = 'flex';
};

window.dashCloseRequest = function() {
  var modal = document.getElementById('requestModal');
  if (modal) modal.style.display = 'none';
  currentRequestType = '';
};

window.dashSubmitRequest = async function() {
  var btn = document.getElementById('reqModalBtn');
  var msg = document.getElementById('reqModalMsg');

  var customerIdEl = document.getElementById('dash-customer-id');
  var customerEmailEl = document.getElementById('dash-customer-email');
  if (!customerIdEl || !customerIdEl.value) {
    if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Pre odoslanie pokynu sa mus\u00edte prihl\u00e1si\u0165.'; }
    return;
  }

  // Collect type-specific details
  var details = {};
  if (currentRequestType === 'GOLD_DELIVERY') {
    var dm = document.getElementById('reqDeliveryMethod');
    if (!dm || !dm.value) { if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Vyberte sp\u00f4sob doru\u010denia.'; } return; }
    details.deliveryMethod = dm.value;
    var n = document.getElementById('reqNote');
    if (n && n.value) details.note = n.value;
  } else if (currentRequestType === 'BUYBACK') {
    var g = document.getElementById('reqGrams');
    if (!g || !g.value || parseFloat(g.value) <= 0) { if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Zadajte po\u010det gramov.'; } return; }
    details.gramsRequested = g.value;
    var n2 = document.getElementById('reqNote');
    if (n2 && n2.value) details.note = n2.value;
  } else if (currentRequestType === 'RENTA') {
    var rt = document.getElementById('reqRentaType');
    var ra = document.getElementById('reqRentaAmount');
    if (!rt || !rt.value) { if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Vyberte typ renty.'; } return; }
    if (!ra || !ra.value) { if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Zadajte v\u00fd\u0161ku renty.'; } return; }
    details.rentaType = rt.value;
    details.rentaAmount = ra.value;
  } else if (currentRequestType === 'EXTEND_PPN') {
    var em = document.getElementById('reqExtensionMonths');
    details.extensionMonths = em ? em.value : '12';
  } else if (currentRequestType === 'EXTRA_DEPOSIT') {
    var ea = document.getElementById('reqExtraAmount');
    if (!ea || !ea.value) { if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Zadajte sumu vkladu.'; } return; }
    details.extraAmount = ea.value;
  } else if (currentRequestType === 'DISPONENT') {
    var dn = document.getElementById('reqDisponentName');
    var de = document.getElementById('reqDisponentEmail');
    var da = document.getElementById('reqDisponentAction');
    if (!dn || !dn.value) { if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Zadajte meno disponenta.'; } return; }
    if (!de || !de.value) { if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = 'Zadajte e-mail disponenta.'; } return; }
    details.disponentName = dn.value;
    details.disponentEmail = de.value;
    details.disponentAction = da ? da.value : 'ADD';
  }

  if (btn) { btn.disabled = true; btn.textContent = 'Odosielam...'; }
  if (msg) msg.style.display = 'none';

  try {
    var response = await fetch(AURUM_API_BASE + '/api/customer/submit-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: customerIdEl.value,
        customerEmail: (customerEmailEl || {}).value || '',
        requestType: currentRequestType,
        details: details
      })
    });
    var result = await response.json();
    if (!response.ok || !result.success) throw new Error(result.error || 'Odoslanie pokynu zlyhalo.');

    if (msg) { msg.style.display = 'block'; msg.style.color = '#2ecc71'; msg.textContent = result.message || 'Pokyn bol \u00faspe\u0161ne odoslan\u00fd.'; }
    if (btn) { btn.disabled = true; btn.textContent = 'Odoslan\u00e9'; }

    // Auto-close after 3s
    setTimeout(function() { dashCloseRequest(); }, 3000);
  } catch (err) {
    var errorMsg = (err && err.message) ? err.message : 'Nepodarilo sa odosla\u0165 pokyn.';
    if (msg) { msg.style.display = 'block'; msg.style.color = '#e74c3c'; msg.textContent = errorMsg; }
    if (btn) { btn.disabled = false; btn.textContent = 'Odosla\u0165 pokyn'; }
  }
};

// ══════════════════════════════════════════════
// DASHBOARD — Document Downloads
// ══════════════════════════════════════════════
window.dashDownloadDoc = function(docType) {
  var customerIdEl = document.getElementById('dash-customer-id');
  if (!customerIdEl || !customerIdEl.value) return;

  var customerId = customerIdEl.value;
  if (docType === 'contract') {
    window.open('https://aurum-api.vercel.app/api/generate-contract/' + customerId, '_blank');
  } else if (docType === 'statement') {
    window.open('https://aurum-api.vercel.app/api/generate-statement/' + customerId, '_blank');
  }
};

document.addEventListener('DOMContentLoaded', function() {
  var el = document.getElementById('dash-customer-id');
  if (el && el.value) {
    dashSwitchTab('prehled');
    dashLoadData();
  }
});

// ══ PARTNER ZONE Functions ══
window.partnerDoLogin = function() {
  var email = document.getElementById('partnerLoginEmail');
  var displayEmail = (email && email.value) ? email.value : 'demo.partner@aurumfinance.sk';
  document.getElementById('partnerChoiceScreen').style.display = 'none';
  var dash = document.getElementById('partnerDashboard');
  if (dash) dash.style.display = 'block';
  var pe = document.getElementById('partnerDashEmail');
  if (pe) pe.textContent = displayEmail;
  window.partnerSwitchTab('zmluvy');
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

window.collabDoLogin = function() {
  var collabEmail = document.getElementById('collabLoginEmail');
  var collabPass = document.getElementById('collabLoginPassword');
  var partnerEmail = document.getElementById('partnerLoginEmail');
  var partnerPass = document.getElementById('partnerLoginPassword');
  if (partnerEmail && collabEmail) partnerEmail.value = collabEmail.value || '';
  if (partnerPass && collabPass) partnerPass.value = collabPass.value || '';
  window.showPage('zona-partner');
  setTimeout(function() { window.partnerDoLogin(); }, 150);
};

window.partnerLogout = function() {
  document.getElementById('partnerDashboard').style.display = 'none';
  document.getElementById('partnerChoiceScreen').style.display = 'block';
  var email = document.getElementById('partnerLoginEmail');
  var pass = document.getElementById('partnerLoginPassword');
  if (email) email.value = '';
  if (pass) pass.value = '';
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

window.partnerSwitchTab = function(tabName) {
  // Get only partner dashboard tabs (inside #partnerDashboard)
  var dashboard = document.getElementById('partnerDashboard');
  if (!dashboard) return;
  dashboard.querySelectorAll('.dash-tab').forEach(function(tab) {
    tab.classList.remove('active');
    if (tab.getAttribute('onclick') && tab.getAttribute('onclick').indexOf("'" + tabName + "'") >= 0) {
      tab.classList.add('active');
    }
  });
  dashboard.querySelectorAll('.dash-tab-panel').forEach(function(panel) {
    panel.classList.remove('active');
    if (panel.getAttribute('data-ptab') === tabName) {
      panel.classList.add('active');
    }
  });
};

// ── PPN Simulator ──
function simAmountChanged() {
  var sel = document.getElementById('simAmountSelect');
  var custom = document.getElementById('simAmountCustom');
  var hidden = document.getElementById('simAmount');
  if (sel.value === 'custom') {
    custom.style.display = 'block';
    custom.focus();
    if (custom.value) hidden.value = custom.value;
  } else {
    custom.style.display = 'none';
    hidden.value = sel.value;
  }
  simCalc();
}

function simCustomAmountInput() {
  var custom = document.getElementById('simAmountCustom');
  var hidden = document.getElementById('simAmount');
  if (custom.value) hidden.value = custom.value;
  simCalc();
}

// simCalc() is defined in aurum-ppn-simulator.js (loaded after this file)

// Chart tab switching
function simChartSwitch(tab) {
  var tabs = document.querySelectorAll('.sim-chart-tab');
  tabs.forEach(function(t) { t.classList.remove('active'); });
  document.getElementById('simPanelGraf').classList.remove('active');
  document.getElementById('simPanelTabulka').classList.remove('active');
  if (tab === 'graf') {
    tabs[0].classList.add('active');
    document.getElementById('simPanelGraf').classList.add('active');
  } else {
    tabs[1].classList.add('active');
    document.getElementById('simPanelTabulka').classList.add('active');
  }
}

// Draw chart on canvas
function simDrawChart(data) {
  var canvas = document.getElementById('simChart');
  if (!canvas) return;
  var wrap = canvas.parentElement;
  var dpr = window.devicePixelRatio || 1;
  var w = wrap.offsetWidth;
  var h = wrap.offsetHeight;
  if (w < 10 || h < 10) return; // skip if container not visible yet
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  canvas.style.width = w + 'px';
  canvas.style.height = h + 'px';
  var ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);

  // Colors
  var goldColor = '#C9A84C';
  var tealColor = '#2dd4a8';
  var gridColor = 'rgba(255,255,255,0.07)';
  var textColor = '#666054';
  var bgColor = '#111111';

  // Clear
  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, w, h);

  // Margins
  var ml = 70, mr = 25, mt = 20, mb = 40;
  var cw = w - ml - mr;
  var ch = h - mt - mb;

  // Data ranges
  var maxVal = 0;
  data.forEach(function(d) { maxVal = Math.max(maxVal, d.fundValue, d.deposited); });
  // Round up to nice number
  var niceMax = Math.ceil(maxVal / 1000) * 1000;
  if (niceMax < 1000) niceMax = 1000;
  var steps = 7;
  var stepVal = niceMax / steps;
  // Recalculate nice step
  if (stepVal > 5000) { stepVal = Math.ceil(stepVal / 5000) * 5000; }
  else if (stepVal > 1000) { stepVal = Math.ceil(stepVal / 1000) * 1000; }
  else if (stepVal > 500) { stepVal = Math.ceil(stepVal / 500) * 500; }
  else { stepVal = Math.ceil(stepVal / 100) * 100; }
  niceMax = stepVal * steps;

  // Y-axis grid lines & labels
  ctx.font = '12px Outfit, sans-serif';
  ctx.textAlign = 'right';
  ctx.textBaseline = 'middle';
  for (var s = 0; s <= steps; s++) {
    var val = s * stepVal;
    var y = mt + ch - (val / niceMax) * ch;
    // Grid line
    ctx.strokeStyle = gridColor;
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(ml, y);
    ctx.lineTo(ml + cw, y);
    ctx.stroke();
    // Label
    ctx.fillStyle = textColor;
    var label = val >= 1000 ? (val / 1000).toLocaleString('sk-SK') + ' 000 €' : val + ' €';
    if (val === 0) label = '0 €';
    ctx.fillText(label, ml - 10, y);
  }

  // X-axis labels
  ctx.textAlign = 'center';
  ctx.textBaseline = 'top';
  ctx.fillStyle = textColor;
  var n = data.length;
  data.forEach(function(d, i) {
    var x = ml + (i / (n - 1)) * cw;
    ctx.fillText(d.year, x, mt + ch + 12);
  });

  // Helper: get point coordinates
  function getXY(i, val) {
    return {
      x: ml + (i / (n - 1)) * cw,
      y: mt + ch - (val / niceMax) * ch
    };
  }

  // Draw line with gradient fill
  function drawLine(dataKey, color, fillAlpha) {
    ctx.strokeStyle = color;
    ctx.lineWidth = 2.5;
    ctx.lineJoin = 'round';
    ctx.beginPath();
    data.forEach(function(d, i) {
      var pt = getXY(i, d[dataKey]);
      if (i === 0) ctx.moveTo(pt.x, pt.y);
      else ctx.lineTo(pt.x, pt.y);
    });
    ctx.stroke();

    // Subtle fill under line
    if (fillAlpha) {
      ctx.beginPath();
      data.forEach(function(d, i) {
        var pt = getXY(i, d[dataKey]);
        if (i === 0) ctx.moveTo(pt.x, pt.y);
        else ctx.lineTo(pt.x, pt.y);
      });
      var lastPt = getXY(n - 1, data[n - 1][dataKey]);
      var firstPt = getXY(0, data[0][dataKey]);
      ctx.lineTo(lastPt.x, mt + ch);
      ctx.lineTo(firstPt.x, mt + ch);
      ctx.closePath();
      ctx.fillStyle = (function(hex, alpha) {
        var r = parseInt(hex.slice(1,3),16);
        var g = parseInt(hex.slice(3,5),16);
        var b = parseInt(hex.slice(5,7),16);
        return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
      })(color, fillAlpha);
      ctx.fill();
    }

    // Draw dots at data points
    data.forEach(function(d, i) {
      var pt = getXY(i, d[dataKey]);
      ctx.beginPath();
      ctx.arc(pt.x, pt.y, 4, 0, Math.PI * 2);
      ctx.fillStyle = color;
      ctx.fill();
      ctx.strokeStyle = bgColor;
      ctx.lineWidth = 2;
      ctx.stroke();
    });
  }

  // Draw deposited line (teal) then fund value line (gold)
  drawLine('deposited', tealColor, 0.08);
  drawLine('fundValue', goldColor, 0.12);
}

// Populate table
function simPopulateTable(data) {
  var tbody = document.getElementById('simTableBody');
  if (!tbody) return;
  tbody.innerHTML = '';
  data.forEach(function(d) {
    var tr = document.createElement('tr');
    tr.innerHTML = '<td>' + d.year + '</td>' +
      '<td>' + d.deposited.toLocaleString('sk-SK') + ' €</td>' +
      '<td>' + d.grams.toFixed(2) + ' g</td>' +
      '<td>' + d.goldPriceAtYear.toFixed(2) + ' €</td>' +
      '<td style="color:var(--gold);font-weight:600;">' + d.fundValue.toLocaleString('sk-SK') + ' €</td>';
    tbody.appendChild(tr);
  });
}

// Initial calculation
if (typeof simCalc === 'function') simCalc();

// Re-draw chart when savings page becomes visible
var savingsObs = new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    if (m.attributeName === 'class') {
      var page = m.target;
      if (page.classList.contains('active') && page.offsetWidth > 0) {
        setTimeout(function() {
          var klasickePanel = document.getElementById('panelKlasicke');
          var rentaPanel = document.getElementById('panelRenta');
          if (klasickePanel && klasickePanel.classList.contains('active')) {
            if (typeof simCalc === 'function') simCalc();
          }
          if (rentaPanel && rentaPanel.classList.contains('active')) {
            if (typeof rentaCalc === 'function') rentaCalc();
          }
        }, 200);
      }
    }
  });
});
var savingsPage = document.querySelector('[data-page="savings"]');
if (savingsPage) {
  savingsObs.observe(savingsPage, { attributes: true, attributeFilter: ['class'] });
}

// Also re-draw on window resize
window.addEventListener('resize', function() {
  var canvas = document.getElementById('simChart');
  if (canvas && canvas.offsetWidth > 0 && typeof simCalc === 'function') simCalc();
  var rentaCanvas = document.getElementById('rentaChart');
  if (rentaCanvas && rentaCanvas.offsetWidth > 0) {
    var rentaPanel = document.getElementById('panelRenta');
    if (rentaPanel && rentaPanel.classList.contains('active')) rentaCalc();
  }
});

// ══════════════════════════════════════════
// CALCULATOR MODE SWITCHING
// ══════════════════════════════════════════
function switchCalcMode(mode) {
  // Toggle tab active
  document.querySelectorAll('.calc-mode-tab').forEach(function(t) { t.classList.remove('active'); });
  if (mode === 'renta') {
    document.querySelectorAll('.calc-mode-tab')[1].classList.add('active');
  } else {
    document.querySelectorAll('.calc-mode-tab')[0].classList.add('active');
  }
  // Toggle panels
  document.querySelectorAll('.calc-mode-panel').forEach(function(p) { p.classList.remove('active'); });
  if (mode === 'renta') {
    document.getElementById('panelRenta').classList.add('active');
    setTimeout(rentaCalc, 100);
  } else {
    document.getElementById('panelKlasicke').classList.add('active');
    if (typeof simCalc === 'function') setTimeout(simCalc, 100);
  }
}

// ══════════════════════════════════════════
// RENTA CALCULATOR
// ══════════════════════════════════════════
var rentaYearlyData = [];

function rentaCalc() {
  var yearsInvest = parseInt(document.getElementById('rentaYearsInvest').value) || 10;
  var monthly = parseFloat(document.getElementById('rentaMonthlyVal').value) || 100;
  var yearsPayout = parseInt(document.getElementById('rentaYearsPayoutVal').value) || 10;
  var goldPrice = parseFloat(document.getElementById('rentaGoldPriceVal').value) || 87;
  var annualGrowth = (parseFloat(document.getElementById('rentaGrowthVal').value) || 7.5) / 100;

  // ── Phase 1: Accumulation (compound interest) ──
  var monthlyRate = annualGrowth / 12;
  var totalInvested = 0;
  var data = [];
  var startYear = new Date().getFullYear();
  var accumulatedValue = 0;

  for (var y = 0; y < yearsInvest; y++) {
    totalInvested += monthly * 12;
    // Compound interest month by month for this year's snapshot
    var yearValue = 0;
    var monthsElapsed = (y + 1) * 12;
    for (var m = 0; m < monthsElapsed; m++) {
      yearValue = yearValue * (1 + monthlyRate) + monthly;
    }
    var currentPrice = goldPrice * Math.pow(1 + annualGrowth, y + 1);
    var goldGrams = yearValue / currentPrice;

    data.push({
      year: startYear + y,
      invested: Math.round(totalInvested),
      fundValue: Math.round(yearValue),
      goldGrams: goldGrams.toFixed(2),
      pricePerGram: currentPrice.toFixed(2),
      phase: 'Sporenie'
    });
  }

  // Full accumulation value at end of investment period
  accumulatedValue = 0;
  var investmentMonths = yearsInvest * 12;
  for (var mi = 0; mi < investmentMonths; mi++) {
    accumulatedValue = accumulatedValue * (1 + monthlyRate) + monthly;
  }
  var finalGoldGrams = accumulatedValue / (goldPrice * Math.pow(1 + annualGrowth, yearsInvest));

  // ── Phase 2: Payout (annuity formula) ──
  var totalPayoutMonths = yearsPayout * 12;
  var monthlyPayout;
  if (monthlyRate > 0) {
    monthlyPayout = accumulatedValue * (monthlyRate / (1 - Math.pow(1 + monthlyRate, -totalPayoutMonths)));
  } else {
    monthlyPayout = accumulatedValue / totalPayoutMonths;
  }

  var remainingValue = accumulatedValue;
  for (var y2 = 0; y2 < yearsPayout; y2++) {
    for (var m2 = 0; m2 < 12; m2++) {
      remainingValue = remainingValue * (1 + monthlyRate) - monthlyPayout;
      if (remainingValue < 0) remainingValue = 0;
    }
    var payoutPrice = goldPrice * Math.pow(1 + annualGrowth, yearsInvest + y2 + 1);
    data.push({
      year: startYear + yearsInvest + y2,
      invested: Math.round(totalInvested),
      fundValue: Math.round(remainingValue),
      goldGrams: (remainingValue / payoutPrice).toFixed(2),
      pricePerGram: payoutPrice.toFixed(2),
      phase: 'Renta'
    });
  }

  rentaYearlyData = data;

  // ── Update result box ──
  var endPrice = goldPrice * Math.pow(1 + annualGrowth, yearsInvest);
  document.getElementById('rentaResultAmount').textContent = monthlyPayout.toFixed(2) + ' EUR';
  document.getElementById('rentaResultGrams').textContent = finalGoldGrams.toFixed(2) + ' g zlata (' + endPrice.toFixed(3) + ' EUR/g)';
  document.getElementById('rentaResultDesc').innerHTML =
    'Po <strong>' + yearsInvest + '</strong> rokoch investovania <strong>' + Math.round(monthly) + '</strong> EUR/mesiac budete dostávať mesačnú rentu po dobu <strong>' + yearsPayout + '</strong> rokov';

  // ── Draw chart & table ──
  rentaDrawChart(data, yearsInvest);
  rentaPopulateTable(data);
}

// ── Renta Chart Switch ──
function rentaChartSwitch(tab) {
  var grafP = document.getElementById('rentaPanelGraf');
  var tabP = document.getElementById('rentaPanelTabulka');
  var tabs = grafP.closest('.sim-chart-section').querySelectorAll('.sim-chart-tab');
  tabs.forEach(function(t) { t.classList.remove('active'); });
  if (tab === 'tabulka') {
    grafP.classList.remove('active');
    tabP.classList.add('active');
    tabs[1].classList.add('active');
  } else {
    tabP.classList.remove('active');
    grafP.classList.add('active');
    tabs[0].classList.add('active');
    setTimeout(function() { rentaDrawChart(rentaYearlyData, parseInt(document.getElementById('rentaYearsInvest').value)); }, 50);
  }
}

// ── Renta Draw Chart ──
function rentaDrawChart(data, investYears) {
  var canvas = document.getElementById('rentaChart');
  if (!canvas || !canvas.getContext) return;
  var wrap = canvas.parentElement;
  if (!wrap || wrap.offsetWidth === 0) return;

  var dpr = window.devicePixelRatio || 1;
  var w = wrap.offsetWidth;
  var h = wrap.offsetHeight || 350;
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  canvas.style.width = w + 'px';
  canvas.style.height = h + 'px';

  var ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);
  ctx.clearRect(0, 0, w, h);

  if (!data || data.length === 0) return;

  var pad = { top: 20, right: 20, bottom: 50, left: 70 };
  var chartW = w - pad.left - pad.right;
  var chartH = h - pad.top - pad.bottom;

  // Gather values
  var maxVal = 0;
  var labels = [];
  var investedVals = [];
  var fundVals = [];

  data.forEach(function(d) {
    labels.push(d.year);
    investedVals.push(d.invested);
    fundVals.push(d.fundValue);
    if (d.invested > maxVal) maxVal = d.invested;
    if (d.fundValue > maxVal) maxVal = d.fundValue;
  });

  maxVal = Math.ceil(maxVal / 5000) * 5000;
  if (maxVal === 0) maxVal = 1000;

  var n = data.length;

  function x(i) { return pad.left + (i / (n - 1)) * chartW; }
  function y(v) { return pad.top + chartH - (v / maxVal) * chartH; }

  function hexToRgba(hex, a) {
    var r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
    return 'rgba('+r+','+g+','+b+','+a+')';
  }

  // Grid
  ctx.strokeStyle = 'rgba(255,255,255,0.06)';
  ctx.lineWidth = 1;
  var gridSteps = 5;
  for (var g = 0; g <= gridSteps; g++) {
    var gy = pad.top + (g / gridSteps) * chartH;
    ctx.beginPath(); ctx.moveTo(pad.left, gy); ctx.lineTo(w - pad.right, gy); ctx.stroke();
    var gVal = maxVal - (g / gridSteps) * maxVal;
    ctx.fillStyle = '#666054';
    ctx.font = '11px Outfit';
    ctx.textAlign = 'right';
    ctx.fillText(Math.round(gVal).toLocaleString('sk') + ' €', pad.left - 10, gy + 4);
  }

  // X labels
  ctx.textAlign = 'center';
  ctx.fillStyle = '#666054';
  ctx.font = '10px Outfit';
  var skipX = Math.ceil(n / 12);
  for (var i = 0; i < n; i++) {
    if (i % skipX === 0 || i === n - 1) {
      ctx.save();
      ctx.translate(x(i), h - 8);
      ctx.rotate(-Math.PI / 6);
      ctx.fillText(labels[i], 0, 0);
      ctx.restore();
    }
  }

  // Phase separator line
  if (investYears > 0 && investYears < n) {
    var sepX = x(investYears - 0.5);
    ctx.strokeStyle = 'rgba(201,168,76,0.3)';
    ctx.setLineDash([4, 4]);
    ctx.beginPath(); ctx.moveTo(sepX, pad.top); ctx.lineTo(sepX, pad.top + chartH); ctx.stroke();
    ctx.setLineDash([]);
    ctx.fillStyle = 'rgba(201,168,76,0.5)';
    ctx.font = '10px Outfit';
    ctx.textAlign = 'center';
    ctx.fillText('← Sporenie | Renta →', sepX, pad.top + 12);
  }

  // Draw line helper
  function drawLine(vals, color, fillAlpha) {
    // Fill
    ctx.beginPath();
    ctx.moveTo(x(0), y(0));
    for (var i = 0; i < vals.length; i++) ctx.lineTo(x(i), y(vals[i]));
    ctx.lineTo(x(vals.length - 1), y(0));
    ctx.closePath();
    var grad = ctx.createLinearGradient(0, pad.top, 0, pad.top + chartH);
    grad.addColorStop(0, hexToRgba(color, fillAlpha));
    grad.addColorStop(1, hexToRgba(color, 0));
    ctx.fillStyle = grad;
    ctx.fill();

    // Line
    ctx.beginPath();
    for (var i = 0; i < vals.length; i++) {
      if (i === 0) ctx.moveTo(x(i), y(vals[i]));
      else ctx.lineTo(x(i), y(vals[i]));
    }
    ctx.strokeStyle = color;
    ctx.lineWidth = 2.5;
    ctx.stroke();

    // Dots
    for (var i = 0; i < vals.length; i++) {
      ctx.beginPath();
      ctx.arc(x(i), y(vals[i]), 4, 0, Math.PI * 2);
      ctx.fillStyle = '#0A0A0A';
      ctx.fill();
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.stroke();
    }
  }

  drawLine(investedVals, '#2dd4a8', 0.08);
  drawLine(fundVals, '#C9A84C', 0.12);
}

// ── Renta Table ──
function rentaPopulateTable(data) {
  var tbody = document.getElementById('rentaTableBody');
  if (!tbody) return;
  tbody.innerHTML = '';
  data.forEach(function(d) {
    var tr = document.createElement('tr');
    if (d.phase === 'Renta') tr.style.background = 'rgba(201,168,76,0.05)';
    tr.innerHTML =
      '<td>' + d.year + '</td>' +
      '<td>' + d.invested.toLocaleString('sk') + ' €</td>' +
      '<td>' + d.fundValue.toLocaleString('sk') + ' €</td>' +
      '<td>' + parseFloat(d.pricePerGram).toFixed(2) + ' €</td>' +
      '<td style="color:' + (d.phase === 'Renta' ? '#C9A84C' : '#2dd4a8') + ';">' + d.phase + '</td>';
    tbody.appendChild(tr);
  });
}

// Initial renta calc (deferred)
setTimeout(function() {
  if (document.getElementById('panelRenta')) rentaCalc();
}, 300);

// ═══ PRODUCT DETAIL MODAL ═══
function openProductModal(card) {
  var modal = document.getElementById('productModal');
  var title = card.querySelector('h4').textContent;
  var price = card.querySelector('.product-price').textContent;
  var weight = card.querySelector('.product-weight').textContent;
  var stockEl = card.querySelector('.product-stock');
  var stock = stockEl ? stockEl.textContent : 'Na objednávku';
  var isInStock = stockEl && stockEl.classList.contains('in-stock');
  var imgsStr = card.getAttribute('data-imgs') || '';
  var imgs = imgsStr ? imgsStr.split('|') : [];

  document.getElementById('modalTitle').textContent = title;
  document.getElementById('modalPrice').textContent = price;
  document.getElementById('modalWeight').textContent = weight.split('·').pop().trim();
  
  var stockModal = document.getElementById('modalStock');
  stockModal.textContent = stock;
  stockModal.className = 'product-stock ' + (isInStock ? 'in-stock' : 'on-order');

  var mainImg = document.getElementById('modalMainImg');
  mainImg.src = imgs.length > 0 ? imgs[0] : '';
  mainImg.alt = title;

  var thumbs = document.getElementById('modalThumbs');
  thumbs.innerHTML = '';
  imgs.forEach(function(src, i) {
    var btn = document.createElement('button');
    btn.className = 'modal-thumb' + (i === 0 ? ' active' : '');
    btn.innerHTML = '<img src="' + src + '" alt="' + title + ' — obrázok ' + (i+1) + '">';
    btn.onclick = function() {
      mainImg.src = src;
      thumbs.querySelectorAll('.modal-thumb').forEach(function(t) { t.classList.remove('active'); });
      btn.classList.add('active');
    };
    thumbs.appendChild(btn);
  });

  var cartBtn = document.getElementById('modalCartBtn');
  var variantId = card.getAttribute('data-variant-id') || '';
  cartBtn.setAttribute('data-variant-id', variantId);
  cartBtn.disabled = false;
  if (isInStock) {
    cartBtn.className = 'product-cart-btn';
    cartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Pridať do košíka';
  } else {
    cartBtn.className = 'product-cart-btn btn-order';
    cartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Na objednávku';
  }
  
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeProductModal() {
  document.getElementById('productModal').classList.remove('active');
  document.body.style.overflow = '';
}
var _productModal = document.getElementById('productModal');
if (_productModal) {
  _productModal.addEventListener('click', function(e) {
    if (e.target === this) closeProductModal();
  });
}

// ═══ BLOG EXPAND/COLLAPSE ═══
function toggleBlogFull(btn) {
  var card = btn.closest('.blog-card');
  var full = card.querySelector('.blog-card-full');
  if (full.classList.contains('visible')) {
    full.classList.remove('visible');
    btn.textContent = 'Čítať viac →';
  } else {
    full.classList.add('visible');
    btn.textContent = 'Skryť ↑';
  }
}

// ═══ AUTO-NEWS FETCH (Gold RSS via rss2json proxy) ═══
(function loadGoldNews() {
  var container = document.getElementById('newsAutoContainer');
  if (!container) return;

  // Fallback articles in case RSS fails
  var fallbackArticles = [
    {
      title: 'Cena zlata dosiahla nové historické maximum nad 2 900 USD za uncu',
      desc: 'Rastúci dopyt centrálnych bánk a geopolitická neistota tlačia cenu zlata na rekordné úrovne. Analytici očakávajú pokračovanie rastového trendu aj v priebehu roka 2026.',
      date: '2026-02-20',
      source: 'Kitco News',
      url: 'https://www.kitco.com/news/gold'
    },
    {
      title: 'Poľská národná banka zvýšila rezervy zlata o 20 ton',
      desc: 'Poľsko pokračuje v agresívnom nakupovaní zlata, čím posilňuje svoju pozíciu medzi najväčšími európskymi držiteľmi zlatých rezerv.',
      date: '2026-02-18',
      source: 'Reuters',
      url: 'https://www.reuters.com/markets/commodities/'
    },
    {
      title: 'World Gold Council: Dopyt po zlate v roku 2025 prekonal 4 800 ton',
      desc: 'Celosvetový dopyt po zlate dosiahol nový rekord, pričom investičný dopyt vzrástol o 25 % medziročne. Kľúčovým faktorom bol nákup centrálnych bánk a fyzické ETF.',
      date: '2026-02-15',
      source: 'World Gold Council',
      url: 'https://www.gold.org/goldhub/research/gold-demand-trends'
    },
    {
      title: 'ECB ponechala úrokové sadzby nezmenené — zlato reaguje rastom',
      desc: 'Európska centrálna banka na februárovom zasadnutí ponechala sadzby na rovnakej úrovni. Trhy očakávajú znižovanie v druhom polroku, čo zvýhodňuje zlato ako bezúročné aktívum.',
      date: '2026-02-12',
      source: 'Financial Times',
      url: 'https://www.ft.com/gold'
    }
  ];

  // Try RSS feed via public proxy
  var rssUrl = 'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.kitco.com%2Ffeed%2Fgold-news';
  
  fetch(rssUrl)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status === 'ok' && data.items && data.items.length > 0) {
        renderNews(data.items.slice(0, 4).map(function(item) {
          return {
            title: item.title,
            desc: item.description ? item.description.replace(/<[^>]*>/g, '').substring(0, 200) + '...' : '',
            date: item.pubDate ? item.pubDate.split(' ')[0] : '',
            source: 'Kitco News',
            url: item.link
          };
        }));
      } else {
        renderNews(fallbackArticles);
      }
    })
    .catch(function() {
      renderNews(fallbackArticles);
    });

  function renderNews(articles) {
    var html = '<div class="news-auto-grid">';
    articles.forEach(function(a) {
      var dateFormatted = a.date;
      try {
        var d = new Date(a.date);
        if (!isNaN(d)) {
          var months = ['január','február','marec','apríl','máj','jún','júl','august','september','október','november','december'];
          dateFormatted = d.getDate() + '. ' + months[d.getMonth()] + ' ' + d.getFullYear();
        }
      } catch(e) {}
      
      html += '<div class="news-auto-card">';
      html += '<h4>' + a.title + '</h4>';
      html += '<p>' + a.desc + '</p>';
      html += '<div class="news-auto-meta">';
      html += '<span>' + dateFormatted + '</span>';
      html += '<a href="' + a.url + '" target="_blank" rel="noopener">' + a.source + ' — originálny článok ↗</a>';
      html += '</div></div>';
    });
    html += '</div>';
    container.innerHTML = html;
  }
})();
